// extracted by mini-css-extract-plugin
module.exports = {"switch":"a10a3f92e9--switch--He7wp","indicator":"a10a3f92e9--indicator--jttd7","label":"a10a3f92e9--label--eS7WL"};